import React, { useState, useEffect } from "react";
import SuperAdmin from "../../entities/SuperAdminPage";
import AuthService from "../../api/AuthService";
import LoaderHelper from "../../utils/Loader/LoaderHelper";
import { useAlert } from "../../context/AlertContext";

const SuperAdminPage = () => {

  const [loading, setLoading] = useState(false);
  const [allowance, setAllowance] = useState([]);
  const [fringe, setFringe] = useState([]);
  const [pension, setPension] = useState([]);
  const [tax, setTax] = useState([]);
  const [leave, setLeave] = useState([]);
  const [data, setData] = useState();


  const { showAlert } = useAlert();

  useEffect(() => {
    getAllowance();
    getFringe();
    getPension();
    getTax();
    getLeave();
    getTaxTable();
  }, [])



  const getAllowance = async() =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAdmAllowance();
      if (result?.success) { 
        setAllowance(result?.data?.allowance);

        LoaderHelper.loaderStatus(false);
        
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };


  const getTaxTable = async(data) =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAdmTaxTable(data);
      if (result?.success) { 
        setData(result?.data);

        LoaderHelper.loaderStatus(false);
        
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleTaxTable = async (min, max, fixed, rate, country) => {

    setLoading(true);
    try {
      const result = await AuthService.handleTaxTable(min, max, fixed, rate, country);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };
  const handleAllowance = async (name, tax, id) => {

    setLoading(true);
    try {
      const result = await AuthService.handleSupAllowance(name, tax, id);
      console.log(id, "allowance?._id")
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };

  const getFringe = async() =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAdmFringe();
      if (result?.success) { 
        setFringe(result?.data?.fringes);

        LoaderHelper.loaderStatus(false);
        
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleFringe = async (name, tax, id) => {

    setLoading(true);
    try {
      const result = await AuthService.handleSupFringe(name, tax, id);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
        // console.log(result?.success,"new employe data ---")
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };

  const getPension = async() =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAdmPension();
      if (result?.success) { 
        setPension(result?.data?.fringes);

        LoaderHelper.loaderStatus(false);
        
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handlePension = async (name, tax, id) => {

    setLoading(true);
    try {
      const result = await AuthService.handleSupPension(name, tax, id);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };

  const getTax = async() =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAdmTax();
      if (result?.success) { 
        setTax(result?.data);

        LoaderHelper.loaderStatus(false);
        
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handleTax = async (start, end, id) => {

    setLoading(true);
    try {
      const result = await AuthService.handleSupTax(start, end, id);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };

  const getLeave = async() =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAdmLeave();
      if (result?.success) { 
        setLeave(result?.data);

        LoaderHelper.loaderStatus(false);
        
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handleLeave = async (type, tax, leaveBalance, id) => {
    setLoading(true);
    try {
      const payload = {
        type: type,
        method: "Fixed",
        rate: Number(leaveBalance || 0),
        country: "", // Add if required by backend
        start: "",   // Add if required by backend
        end: "",     // Add if required by backend
      };
      const result = await AuthService.handleSupLeave(payload, id);
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };




  return (
    <SuperAdmin loading={loading} allowances={allowance} handleAllowance={handleAllowance} pensions={pension} handlePension={handlePension}
      fringes={fringe} handleFringe={handleFringe} taxes={tax} handleTax={handleTax} leaves={leave} handleLeave={handleLeave} data={data}
      handleTaxTable={handleTaxTable} getTaxTable={getTaxTable}/>
  )

}

export default SuperAdminPage;
